(function () {
  'use strict';
  const Base = customElements.get('cl-november-shop');
  if (!Base || customElements.get('cl-november-poster-shop')) return;
  class NovemberPosterShop extends Base {
    connectedCallback() {
      this.generation = (this.generation || 0) + 1;
      super.connectedCallback();
      if (!this.card) return;
      this.selection = this.querySelector('.cl-nov__selection');
      this.neighbors = [...this.world.querySelectorAll('[data-nov-offer]')].filter(card=>card!==this.card);
      let saved = false;
      try { saved = Boolean(JSON.parse(sessionStorage.getItem(this.key)||'{}').slots?.length); } catch (_) { /* Optional storage. */ }
      if (!saved && !this.catalog.slots) {
        ['bordo-triko-polo-yaka-tisort','buz-mavisi-triko-polo-yaka-tisort','mint-bisiklet-yaka-tisort'].forEach((handle,index)=>{
          if (!this.slots[index].products.some(p=>p.handle===handle && p.variants.some(v=>v.available))) return;
          this.slots[index].handle=handle; this.slots[index].size=''; this.renderSlot(index);
          this.fields[index].querySelector('select').value=handle;
        });
        this.updateSummary();
      }
      this.pauseButtons=[...this.root.querySelectorAll('[data-poster-pause]')];
      this.pauseButtons.forEach(button=>button.addEventListener('click',()=>{
        this.paused=!this.paused;
        try { sessionStorage.setItem('cl-poster-paused',String(this.paused)); } catch (_) { /* Optional storage. */ }
        this.syncMotion();
      },{signal:this.controller.signal}));
      this.media.addEventListener('change',()=>this.syncMotion(),{signal:this.controller.signal});
      this.syncMotion();
    }
    setDepth() {}
    setupHover(signal) {
      this.paused=false;
      try { this.paused=sessionStorage.getItem('cl-poster-paused')==='true'; } catch (_) { /* Optional storage. */ }
      this.hoverItems=(this.offerCode ? [this.card] : [...this.root.querySelectorAll('[data-nov-offer]')]).map(card=>{
        const stage=card.querySelector('[data-nov-stage]');
        const item={card,stage,visible:true,to:{},frame:0,ribbons:[...stage.querySelectorAll('[data-poster-ribbon]')],particles:[...stage.querySelectorAll('[data-poster-particle]')],figures:[...stage.querySelectorAll('[data-stage-product]')],shine:stage.querySelector('[data-poster-shine]'),backdrop:stage.querySelector('[data-poster-backdrop]'),burst:[...stage.querySelectorAll('[data-poster-burst]')]};
        item.targets=[...item.ribbons,...item.particles,...item.figures,item.shine];
        this.makeQuick(item);
        const respond=(x=.2,y=-.25)=>{
          if (!this.gsap || this.opened || !item.visible || this.paused || this.media.matches) return;
          Object.values(item.to).forEach((to,index)=>{const direction=index%2?1:-1;to.x(x*to.amount*2);to.y(y*to.amount*2+direction*(to.kind==='ribbon'?10:0));to.rotation(to.kind==='product'?0:direction*(6+x*9));});
          this.gsap.to(item.shine,{opacity:.85,duration:.6,overwrite:true});
        };
        stage.addEventListener('pointerenter',event=>{if(event.pointerType!=='touch')respond();},{signal});
        stage.addEventListener('focusin',()=>respond(),{signal});
        stage.addEventListener('pointermove',event=>{
          if (event.pointerType==='touch'||this.opened||this.paused||this.media.matches||!item.visible) return;
          item.pointer={x:event.clientX,y:event.clientY};
          if(item.frame)return;
          item.frame=requestAnimationFrame(()=>{item.frame=0;const r=stage.getBoundingClientRect();respond(Math.max(-.5,Math.min(.5,(item.pointer.x-r.left)/r.width-.5)),Math.max(-.5,Math.min(.5,(item.pointer.y-r.top)/r.height-.5)));});
        },{signal});
        stage.addEventListener('pointerleave',()=>this.restHover(item),{signal});
        stage.addEventListener('focusout',()=>this.restHover(item),{signal});
        return item;
      });
      this.visibilityObserver=new IntersectionObserver(entries=>entries.forEach(entry=>{
        const item=this.hoverItems.find(item=>item.stage===entry.target);if(!item)return;
        item.visible=entry.isIntersecting;
        if(!item.visible){this.restHover(item,true);if(item.card===this.card)this.stopAmbient();}
        else if(this.opened && item.card===this.card && this.viewport.dataset.posterSettled)this.startAmbient();
      }));
      this.hoverItems.forEach(item=>this.visibilityObserver.observe(item.stage));
      document.addEventListener('visibilitychange',()=>{if(document.hidden){this.stopAmbient();this.resetHover(true);}else if(this.opened)this.startAmbient();},{signal});
    }
    makeQuick(item) {
      Object.values(item.to||{}).forEach(to=>['x','y','rotation'].forEach(prop=>to[prop]?.tween?.kill()));
      item.to={};
      if (this.gsap) item.targets.forEach((target,index)=>{
          const kind=item.ribbons.includes(target)?'ribbon':item.figures.includes(target)?'product':item.particles.includes(target)?'particle':'shine';
          const amount=kind==='product'?5:kind==='ribbon'?18:kind==='particle'?12+(index%3)*4:22;
          item.to[index]={kind,amount,x:this.gsap.quickTo(target,'x',{duration:.7,ease:'power3.out'}),y:this.gsap.quickTo(target,'y',{duration:.85,ease:'power3.out'}),rotation:this.gsap.quickTo(target,'rotation',{duration:.9,ease:'power2.out'})};
        });
    }
    restHover(item,immediate=false) {
      cancelAnimationFrame(item.frame);item.frame=0;
      if(this.opened && item.card===this.card)return;
      if(!this.gsap)return;
      const immediateReturn=immediate||this.paused||this.media.matches||!item.visible;
      Object.values(item.to).forEach(to=>['x','y','rotation'].forEach(prop=>{to[prop](0);if(immediateReturn)to[prop].tween.progress(1);}));
      this.gsap.to(item.shine,{opacity:0,duration:immediateReturn?0:.7,overwrite:'auto'});
    }
    resetHover(immediate=false) { this.hoverItems?.forEach(item=>this.restHover(item,immediate)); }
    syncMotion() {
      const reduced=this.media.matches;
      this.pauseButtons?.forEach(button=>{button.disabled=reduced;button.setAttribute('aria-pressed',String(this.paused||reduced));button.textContent=reduced?'Hareketler azaltıldı':this.paused?'Hareketi sürdür':'Hareketi duraklat';});
      if(this.paused||reduced){this.stopAmbient();this.resetHover(true);this.burstTimeline?.kill();this.gsap?.set(this.selected()?.burst||[],{opacity:0});}
      else if(this.opened && !this.closing && this.viewport.dataset.posterSettled)this.startAmbient();
    }
    selected() { return this.hoverItems?.find(item=>item.card===this.card); }
    stopAmbient() { this.ambient?.kill();this.ambient=null; }
    startAmbient() {
      this.stopAmbient();
      const item=this.selected();
      if(!this.gsap||!this.opened||this.closing||this.paused||this.media.matches||document.hidden||!item?.visible)return;
      const slow=this.slowDevice || (navigator.deviceMemory && navigator.deviceMemory<=4);
      const count=slow?3:innerWidth<750?4:7;
      const tl=this.ambient=this.gsap.timeline({repeat:-1,yoyo:true,defaults:{ease:'sine.inOut'}});
      item.ribbons.forEach((r,i)=>tl.to(r,{x:'+='+(i%2?10:-12),y:'+='+(i%2?-15:18),rotation:'+='+(i%2?6:-7),duration:2.6+i*.22},0));
      item.particles.slice(0,count).forEach((p,i)=>tl.to(p,{y:'+='+(18+i*2),x:'+='+(i%2?9:-9),rotation:'+='+(30+i*9),duration:2.8+i*.15},0));
    }
    cameraTarget() {
      const stage=this.card.querySelector('[data-nov-stage]');let x=0,y=0,node=stage;
      while(node&&node!==this.world){x+=node.offsetLeft;y+=node.offsetTop;node=node.offsetParent;}
      const panel=this.querySelector('.cl-nov__selection').getBoundingClientRect();const mobile=innerWidth<=749;
      const area=mobile?{x:12,y:56,w:innerWidth-24,h:panel.top-62}:{x:28,y:86,w:panel.left-66,h:innerHeight-120};
      const crop=mobile?{x:0,y:stage.offsetHeight*.3,w:stage.offsetWidth,h:stage.offsetHeight*.5}:{x:-stage.offsetWidth*.12,y:0,w:stage.offsetWidth*1.24,h:stage.offsetHeight};
      const scale=Math.min(area.w/crop.w,area.h/crop.h,2.7);
      return {x:area.x+(area.w-crop.w*scale)/2-(x+crop.x)*scale,y:area.y+(area.h-crop.h*scale)/2-(y+crop.y)*scale,scale};
    }
    productPose(item,index,open) {
      if(!open)return {x:0,y:0,rotation:0,scale:1};
      if(innerWidth>749)return {x:index===0?8:index===1?-6:0,y:index===2?-4:0,rotation:0,scale:1};
      // Unfold the same three photo nodes into a readable mobile row. Images keep their aspect ratio.
      const figure=item.figures[index],w=item.stage.offsetWidth,h=item.stage.offsetHeight;
      const targetWidth=w*.34,scale=targetWidth/figure.offsetWidth;
      return {x:w*(index*.33)-figure.offsetLeft-(figure.offsetWidth-targetWidth)/2,
        y:h*.35-figure.offsetTop-figure.offsetHeight*(1-scale)/2,
        rotation:-parseFloat(getComputedStyle(figure).rotate||0)||0,scale};
    }
    async open(trigger) {
      if(this.opened&&!this.closing)return;
      const generation=++this.generation;this.stopAmbient();this.burstTimeline?.kill();
      await super.open(trigger);
      if(!this.isConnected||!this.opened||this.closing||generation!==this.generation)return;
      this.transition?.pause(0).kill();this.compose(true);
    }
    compose(open) {
      const item=this.selected();if(!this.gsap){if(!open)this.finishClose();return;}
      Object.values(item.to).forEach(to=>['x','y','rotation'].forEach(prop=>to[prop].tween.pause()));
      const reduced=this.media.matches||this.paused;
      const quiet=this.root.hasAttribute('data-purple-vitrine');
      const duration=reduced?0:open?(innerWidth<750?1.05:1.25):.9;
      const rect=this.anchor.getBoundingClientRect();this.transition?.kill();delete this.viewport.dataset.posterSettled;
      const tl=this.transition=this.gsap.timeline({defaults:{ease:'power3.inOut'},onComplete:()=>{if(open){this.viewport.dataset.posterSettled='true';this.startAmbient();}else this.finishClose();}});
      tl.to(this.world,{...(open?this.cameraTarget():{x:rect.left,y:rect.top,scale:1}),duration},0)
        .to(this.curtain,{opacity:open?1:0,duration:duration*.6},0)
        .to(this.world.querySelectorAll('.cl-nov__body'),{opacity:open?0:1,duration:duration*.2},open?0:duration*.75)
        // Controls become usable early, not after the full decorative entrance.
        .to(this.dialog,{opacity:open?1:0,duration:duration*.2},open?duration*.12:0)
        .to(item.backdrop,{scaleX:open?(quiet?1.08:1.35):1,scaleY:open?1.06:1,duration},0)
        .to(item.shine,{opacity:open?.5:0,x:0,y:0,duration},0);
      item.ribbons.forEach((r,i)=>tl.to(r,{x:open?(i%2?10:-12):0,y:open?(i%2?-10:12):0,rotation:open?(quiet?(i%2?3:-3):(i%2?8:-9)):0,scale:open?(quiet?1.04:1.12):1,duration,ease:'power2.inOut'},0));
      item.figures.forEach((figure,i)=>tl.to(figure,{...this.productPose(item,i,open),duration},0));
      item.particles.forEach((p,i)=>tl.to(p,{x:open?(i%2?12:-12):0,y:open?(i%3-1)*18:0,rotation:open?(i%2?35:-30):0,duration},0));
      this.neighbors.forEach((card,i)=>tl.to(card.querySelector('[data-nov-stage]'),{x:open?55+(i%4)*15:0,rotationY:open?-12:0,scale:open?.9:1,opacity:open?.24:1,transformPerspective:1100,duration},0));
      if(open&&!reduced){
        const mobile=innerWidth<750;const count=mobile?12:22;const w=item.stage.offsetWidth,h=item.stage.offsetHeight;
        this.gsap.set(item.burst,{opacity:0});
        this.burstTimeline=this.gsap.timeline();
        item.burst.slice(0,count).forEach((p,i)=>{
          const angle=(i*137.5-75)*Math.PI/180;const reach=w*(.45+(i%4)*.12);
          this.burstTimeline.fromTo(p,{x:(i%2?1:-1)*w*.3,y:(i%3-1)*h*.12,scale:.3,rotation:0,opacity:0},{x:Math.cos(angle)*reach,y:Math.sin(angle)*reach*.85-h*.1,scale:1+(i%3)*.25,rotation:(i%2?1:-1)*(160+i*13),opacity:1,duration:.8,ease:'power2.out'},i*.012)
            .to(p,{y:'+='+h*.16,opacity:0,scale:.8,duration:.45,ease:'sine.in'},.7+i*.012);
        });
        // One larger foreground curl crosses the near plane, then remains in view.
        if(!quiet)tl.to(item.ribbons[2] || item.ribbons[0],{scale:1.38,duration:duration*.35,ease:'power2.out'},0).to(item.ribbons[2] || item.ribbons[0],{scale:1.12,duration:duration*.65},duration*.35);
        let previous=performance.now(),samples=[];const sample=now=>{samples.push(now-previous);previous=now;if(this.opened && samples.length<36)this.perfFrame=requestAnimationFrame(sample);else this.slowDevice=samples.filter(n=>n>32).length>7;};this.perfFrame=requestAnimationFrame(sample);
      }else {this.burstTimeline?.kill();this.gsap.set(item.burst,{opacity:0});}
    }
    close(immediate=false) {
      if(!this.opened||this.closing)return;
      ++this.generation;this.openRequest=(this.openRequest||0)+1;this.viewport.removeAttribute('aria-busy');this.closing=true;
      this.stopAmbient();this.burstTimeline?.kill();this.gsap?.set(this.selected()?.burst||[],{opacity:0});this.transition?.kill();cancelAnimationFrame(this.perfFrame);
      if(immediate||this.media.matches||this.paused||!this.gsap)this.finishClose();else this.compose(false);
    }
    finishClose(restoreFocus=true) {
      this.stopAmbient();this.burstTimeline?.kill();cancelAnimationFrame(this.perfFrame);
      this.gsap?.set(this.selected()?.burst||[],{opacity:0});
      this.transition?.kill();
      this.hoverItems?.forEach(item=>{this.gsap?.killTweensOf([item.backdrop,item.stage]);this.gsap?.set([item.backdrop,item.stage],{clearProps:'transform,opacity'});if(item.card===this.card){this.gsap?.killTweensOf(item.targets);this.gsap?.set(item.targets,{clearProps:'transform,opacity'});this.makeQuick(item);}});
      if(this.viewport)delete this.viewport.dataset.posterSettled;
      super.finishClose(restoreFocus);
    }
    reframe() {
      if(!this.opened)return;
      if(this.closing){this.finishClose();return;}
      this.transition?.progress(1);this.world.style.width=this.anchor.clientWidth+'px';this.anchor.style.height=this.world.offsetHeight+'px';this.gsap?.set(this.world,this.cameraTarget());const item=this.selected();item.figures.forEach((figure,i)=>this.gsap?.set(figure,this.productPose(item,i,true)));
    }
    disconnectedCallback() {
      ++this.generation;this.stopAmbient();this.burstTimeline?.kill();cancelAnimationFrame(this.perfFrame);
      this.hoverItems?.forEach(item=>{cancelAnimationFrame(item.frame);this.gsap?.killTweensOf([...item.targets,item.backdrop,item.stage,...item.burst]);Object.values(item.to).forEach(to=>['x','y','rotation'].forEach(prop=>to[prop]?.tween?.kill()));});
      super.disconnectedCallback();
    }
  }
  customElements.define('cl-november-poster-shop',NovemberPosterShop);
})();
